export const environment = {
  production: true,

  endpoints: {
    api: 'https://dev-api.man.ax',
    app: 'https://dev-webapp.man.ax',
    webapp: 'https://dev-portal.man.ax',
    socket: 'https://dev-api.man.ax',
  }
};